// Add parts as needed using key names from here: https://react-select.com/styles#style-object

// Instead of using isFocused, isSelected etc as per react-select docs, you can use normal Chakra _hover, _focus, _selected etc
const myDefault = ({ isInvalid, width, menuMinWidth }) => ({
  indicatorSeparator: {
    display: 'none',
  },
  dropdownIndicator: {
    color: 'primary.base',
    backgroundColor: 'gray.100',
    height: '46px',
    borderRadius: '0px 3px 3px 0px',
    borderLeft: '1px solid',
    borderColor: isInvalid ? 'error' : 'border.base',
    padding: '12px 8px 8px 8px',
    alignItems: 'flex-start',
  },
  control: {
    cursor: 'pointer',
    height: 12,
    minHeight: '32px',
    alignItems: 'flex-start',
    border: 'light',
    borderColor: isInvalid ? 'error' : 'border.base',
    boxShadow: 'none',
    _hover: {
      borderColor: isInvalid ? 'error' : 'secondary.tint',
      '.react-select__indicator': {
        borderColor: isInvalid ? 'error' : 'secondary.tint',
      },
    },
    _focus: {
      borderColor: 'secondary.tint',
    },
    '&:focus-within .react-select__indicator': {
      borderColor: 'secondary.tint',
    },
  },
  option: {
    color: 'gray.750',
    fontSize: 'md',
    fontFamily: 'Poppins',
    textAlign: 'left',
    padding: '5px 12px',
    _selected: {
      backgroundColor: 'gray.25',
    },
    _focus: {
      backgroundColor: 'gray.25',
    },
    _hover: {
      backgroundColor: 'gray.25',
    },
    cursor: 'pointer',
  },
  menu: {
    zIndex: 2,
    marginTop: '6px',
    minWidth: menuMinWidth,
  },
  singleValue: {
    fontSize: 'md',
    padding: '5px 12px',
  },
  menuList: {
    py: 0,
  },
  container: {
    width: width ? width : '150px',
  },
  valueContainer: {
    height: '100%',
  },
  indicatorsContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  placeholder: {
    fontSize: 'md',
    color: 'gray.700',
    padding: '5px 12px',
  },
  input: {
    fontSize: 'md',
    padding: '5px 12px',
    width: '100%',
    height: '100%',
  },
});

export default {
  ReactSelect: {
    parts: [
      'clearIndicator',
      'container',
      'control',
      'dropdownIndicator',
      'group',
      'groupHeading',
      'indicatorsContainer',
      'indicatorSeparator',
      'input',
      'loadingIndicator',
      'loadingMessage',
      'menu',
      'menuList',
      'menuPortal',
      'multiValue',
      'multiValueLabel',
      'multiValueRemove',
      'noOptionsMessage',
      'option',
      'placeholder',
      'singleValue',
      'valueContainer',
    ],
    baseStyles: {},
    variants: {
      currencySelect: {
        container: {
          border: 'none',
        },
        valueContainer: {
          padding: '12px 16px',
        },
        control: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 'none',
          border: 'none',
          borderBottom: 'light',
          borderColor: 'border.light',
          _focus: {
            border: 'none',
            boxShadow: 'none',
            borderBottom: 'light',
            borderColor: 'border.light',
          },
          _hover: {
            border: 'none',
            borderBottom: 'light',
            borderColor: 'border.light',
          },
        },
        indicatorSeparator: {
          border: 'none',
        },
        dropdownIndicator: {
          color: 'gray.700',
        },
        menu: {
          borderRadius: 'none',
          position: 'relative',
          boxShadow: 'none',
          border: 'none',
        },
        menuList: {
          border: 'none',
          paddingTop: '16px',
          minHeight: '400px',
        },
        groupHeading: {
          fontSize: 'sm',
          fontWeight: 'semibold',
          textTransform: 'none',
          color: 'text.base',
          paddingX: '16px',
          paddingTop: '8px',
        },
        option: {
          color: 'gray.750',
          fontSize: 'sm',
          fontFamily: 'Poppins',
          _selected: {
            backgroundColor: 'white',
          },
          _focus: {
            backgroundColor: 'gray.25',
          },
          _hover: {
            backgroundColor: 'gray.25',
          },
        },
      },
      default: myDefault,
      filterSelect: {
        indicatorSeparator: {
          display: 'none',
        },
        dropdownIndicator: {
          color: 'primary.base',
          padding: '5px 8px 8px 8px',
          _hover: {
            color: 'primary.light',
          },
          _active: {
            color: 'primary.dark',
          },
          alignItems: 'flex-start',
        },
        control: {
          border: 'light',
          borderColor: 'gray.350',
          boxShadow: 'none',
          _hover: {
            border: 'light',
            borderColor: 'gray.350',
          },
          minHeight: '8',
          height: '8',
          alignItems: 'flex-start',
        },
        option: {
          color: 'gray.750',
          fontSize: 'sm',
          fontFamily: 'Poppins',
          padding: '5px 12px',
          _selected: {
            backgroundColor: 'gray.25',
          },
          _focus: {
            backgroundColor: 'gray.25',
          },
          _hover: {
            backgroundColor: 'gray.25',
          },
        },
        menu: {
          zIndex: 2,
        },
        singleValue: {
          fontSize: 'sm',
        },
        menuList: {
          py: 0,
        },
        container: {
          width: '150px',
        },
        valueContainer: {
          height: '100%',
          padding: '5px 12px',
        },
        indicatorsContainer: {
          height: '100%',
        },
      },
    },
    defaultProps: {
      variant: 'default',
    },
  },
};
